import { render, staticRenderFns } from "./AddEditSpeciality.vue?vue&type=template&id=3acf5dd2"
import script from "./AddEditSpeciality.vue?vue&type=script&lang=js"
export * from "./AddEditSpeciality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports